<template>
  <nav class="navbar">
    <!-- Поисковая панель -->
    <div class="navbar__search-bar">
      <InputSearchPrimary
        placeholder="Поиск"
        size="large"
        :model-value="props.searchField"
        @update:model-value="value => getSourceList(value)"
      />
    </div>

    <!-- импорт и создание -->
    <div class="navbar__action-group">
      <div 
        v-click-outside="() => isShowFilter = false"
        class="navbar__action-wrapper"
      >
        <ButtonNeutralSecondary 
          size="large" 
          :pressed="false" 
          class="navbar__action-button"
          @click="isShowFilter = !isShowFilter"
        >
          <FilterIcon />
          Фильтры
          <span
            class="badge-count"
            :class="{'badge-count--active': props.activeFilterCount > 0}"
          >{{ props.activeFilterCount }}</span>
        </ButtonNeutralSecondary>
        <NavbarFilter
          v-if="isShowFilter"
          :active-filter-count="props.activeFilterCount"
          :filter-tag-options="props.filterTagOptions"
          :filter-options="props.filterOptions"
          @add-filter-tag="args => emit('add-filter-tag', args)"
          @get-filter-fields="args => emit('get-filter-fields', args)"
          @get-filter-tags="args => emit('get-filter-tags', args)"
          @reset-filter="emit('reset-filter')"
          @update-filter="emit('update-filter')"
        />
      </div>
      <div 
        v-click-outside="() => isShowColumnHider = false"
        class="navbar__action-wrapper"
      >
        <ButtonNeutralSecondary
          size="large"
          :pressed="false"
          class="navbar__action-button"
          @click="isShowColumnHider = !isShowColumnHider"
        >
          <BookmarkIcon />
          Столбцы
        </ButtonNeutralSecondary>
        <ColumnHider
          v-if="isShowColumnHider"
          :column-list="columnList"
          @move-column="args => emit('move-column', args)"
          @close-modal="isShowColumnHider = false"
          @toggle-column-hide="args => toggleColumnHide(args)"
        />
      </div>
      <ButtonNeutralSecondary
        size="large"
        :pressed="false"
        class="navbar__action-button"
      >
        <ImportIcon />
        <label for="fileInput">Импорт</label>
        <input
          id="fileInput"
          type="file"
          hidden
          @change="onFileExportChanged($event)"
        >
      </ButtonNeutralSecondary>
      <ButtonAccentPrimary
        size="large"
        :pressed="false"
        class="navbar__action-button"
        @click="emit('create-feed')"
      >
        <PlusIcon />
        Источник
      </ButtonAccentPrimary>
    </div>
  </nav>
</template>

<script setup>
import {ref, defineProps, defineEmits, onMounted} from "vue";
import { useTableStore } from "@/stores/table.js";
import axios from "axios";
import environment from "@/environment";
import ImportIcon from "@/components/icons/ImportIcon.vue";
import FilterIcon from "@/components/icons/FilterIcon.vue";
import PlusIcon from "@/components/icons/PlusIcon.vue";
import NavbarFilter from "@/components/table/NavbarFilter.vue";
import ColumnHider from "@/components/table/TableAction/ColumnHider.vue";
import BookmarkIcon from "@/components/icons/BookmarkIcon.vue";

const props = defineProps({
  searchField: {
    type: String,
    default: () => ""
  },
  filterOptions: {
    type: Array,
    required: true
  },
  filterTagOptions: {
    type: Object,
    required: true
  },
  activeFilterCount: {
    type: Number,
    default: 0
  },
  columnList: {
    type: Array,
    required: true,
    default: () => []
  }
});

const emit = defineEmits(
    ["update:searchField", "create-feed", "getData", "update-filter", "reset-filter", "add-filter-tag", "move-column"]
);

const getSourceList = (value) => {
  emit("update:searchField", value);
  emit("getData");
};

const isShowColumnHider = ref(false);
const isShowFilter = ref(false);

const tableStore = useTableStore();
let file = ref(null);

const onFileExportChanged = async (event) => {
  const target = event.target;
  if (target.files?.length) {
    file.value = target.files[0];
    await uploadFeed(file.value);
    target.value = "";
    file.value = null;
  }
};

const uploadFeed = async (file) => {
  try {
    const url = `${environment.appConfig.baseApiUrl}${environment.postFeed}`;
    const formData = new FormData();
    formData.append("formFiles", file);
    await axios.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (err) {
    console.error(err);
  }
};

const toggleColumnHide = (col) => {
  col.hide = !col.hide;
  const stored = JSON.parse(localStorage.getItem("tableColumnNames")) || [];
  const idx = stored.indexOf(col.name);
  if (idx !== -1) stored.splice(idx, 1);
  else stored.push(col.name);
  localStorage.setItem("tableColumnNames", JSON.stringify(stored));
};

onMounted(() => {
  const stored = JSON.parse(localStorage.getItem("tableColumnNames")) || [];
  stored.forEach((name) => {
    const column = tableStore.headersData.find((c) => c.name === name);
    if (column) column.hide = true;
  });
});
</script>

<style lang="scss" scoped>
.navbar {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;

  &__search-bar {
    flex: 1;
  }

  &__action-group {
    display: flex;
    gap: 10px;
  }

  &__action-wrapper {
    position: relative;
  }

  &__action-button {
    position: relative;
    width: 180px;
    
    label {
      cursor: pointer;
    }

    &--active {
      color: #104AA1;
    }
  }
}

.badge-count {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background: #EEF1F4;
  color: #7B87A5;
  font-weight: 500;
  font-size: 11px;
  line-height: 1;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 0;

  &--active {
    background: #1F9AFF;
    color: #F7F8FD;
  }
}
</style>
